var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('Popup', {
    staticClass: "qrcode-popup",
    attrs: {
      "position": "center",
      "modal": true
    },
    model: {
      value: _vm.popup.visible,
      callback: function callback($$v) {
        _vm.$set(_vm.popup, "visible", $$v);
      },
      expression: "popup.visible"
    }
  }, [_c('div', {
    staticClass: "qrcode-content"
  }, [_vm.popup.title ? _c('div', {
    staticClass: "qrcode-title"
  }, [_vm._v(_vm._s(_vm.popup.title))]) : _vm._e(), _vm.popup.desc ? _c('div', {
    staticClass: "qrcode-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.desc)
    }
  }) : _vm._e(), _vm.popup.src ? _c('img', {
    staticClass: "qrcode-img",
    attrs: {
      "src": _vm.popup.src
    }
  }) : _vm._e(), _vm.popup.desc2 ? _c('div', {
    staticClass: "qrcode-desc2",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.desc2)
    }
  }) : _vm._e(), _vm.popup.neverDisplay ? _c('div', {
    staticClass: "qrcode-never-display gray-color"
  }, [_c('MobileButton', {
    staticClass: "btn-small",
    attrs: {
      "name": "line-normal"
    },
    on: {
      "click": _vm.onClickNeverDisplay
    }
  }, [_c('i', {
    staticClass: "icon",
    "class": {
      'gray-color': _vm.neverDisplay
    }
  }, [_vm._v(_vm._s(_vm.neverDisplay ? '' : ''))]), _vm._v(" 不再提示 ")])], 1) : _vm._e(), _vm.popup.actionText ? _c('div', {
    staticClass: "action-btn-wrap"
  }, [_c('MobileButton', {
    staticClass: "btn-normal btn-round action",
    attrs: {
      "name": "red-gradient"
    },
    on: {
      "click": _vm.popup.actionCb
    }
  }, [_vm._v(_vm._s(_vm.popup.actionText))])], 1) : _vm._e(), _c('i', {
    staticClass: "qrcode-close icon",
    on: {
      "click": _vm.onClickCloseQrcode
    }
  }, [_vm._v("  ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };